import {CSVLink} from 'react-csv';
import {PropsWithChildren, useMemo} from 'react';
import {Exportable, firstOrUndefined, getDataForExport} from "@ots-frontend/ots-data";
import {useTranslation} from "react-i18next";

export type ExportLinkProps<E extends Exportable> = {
  filePrefix?: string;
  data?: E[];
};

export function ExportLink<E extends Exportable>(props: PropsWithChildren<ExportLinkProps<E>>) {
  const {filePrefix, data, children} = props;

  const {t} = useTranslation(["common"])

  const headers = useMemo(() => {
    return firstOrUndefined(data)?.CSV_HEADERS;
  }, [data]);

  const exportData = useMemo(() => {
    return data ? getDataForExport(data) : undefined;
  }, [data]);

  const exportFileName = useMemo(() => {
    let prefix = '';
    if (filePrefix) {
      prefix = filePrefix + '_';
    }

    return prefix + new Date().getTime() + '_export.csv';
  }, [filePrefix]);

  if (exportData && exportData.length > 0) {
    return (
      <CSVLink style={{textDecoration: "none"}} headers={headers} data={exportData} filename={exportFileName}>
        {children ? children : t("common.action.export", "Export")}
      </CSVLink>
    );
  }

  return null;
}
